import "./awards.component.css"
import PixelComponent from "../pixel/pixel.component"
import StrapiImageComponent from "../strapi-image/strapi-image.component"

const AwardsComponent = (props) => {
  const { Awards } = props

  return (
    <div className="dagger-awards">
      <PixelComponent
        className="grid"
        anchor="bottom-left"
        triggerAfterDelay={0.5}
      />
      <PixelComponent
        className="bottom-grid"
        anchor="top-right"
        triggerAfterDelay={0.5}
      />
      {Awards.map((a) => {
        return (
          <div className="dagger-award" key={a.id}>
            <StrapiImageComponent attributes={a.Media.data.attributes} alt={a.Subheading} sizes="96px" />
            <h5>{a.Subheading}</h5>
          </div>
        )
      })}
    </div>
  )
}

export default AwardsComponent
